export enum DirectoryCompanionVariant {
  CONTROL = 'control',
  FIND_MY_FIT = 'find-my-fit',
  CHAT_OPEN = 'chat-open'
}
